var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCard1Px = function SvgCard1Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1953 10H2.19531M11.1953 14H6.19531M2.19531 8.2L2.19531 15.8C2.19531 16.9201 2.19531 17.4802 2.4133 17.908C2.60505 18.2843 2.91101 18.5903 3.28733 18.782C3.71515 19 4.27521 19 5.39531 19L18.9953 19C20.1154 19 20.6755 19 21.1033 18.782C21.4796 18.5903 21.7856 18.2843 21.9773 17.908C22.1953 17.4802 22.1953 16.9201 22.1953 15.8V8.2C22.1953 7.0799 22.1953 6.51984 21.9773 6.09202C21.7856 5.7157 21.4796 5.40974 21.1033 5.21799C20.6755 5 20.1154 5 18.9953 5L5.39531 5C4.27521 5 3.71516 5 3.28733 5.21799C2.91101 5.40973 2.60505 5.71569 2.4133 6.09202C2.19531 6.51984 2.19531 7.07989 2.19531 8.2Z",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCard1Px;